var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 635,
    height: 595,
    viewBox: "0 0 635 595",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.123 103.279H84.1818C80.509 103.279 76.9866 104.738 74.3896 107.335C71.7925 109.932 70.3335 113.454 70.3335 117.127V160.057C70.3335 163.73 71.7925 167.252 74.3896 169.849C76.9866 172.447 80.509 173.906 84.1818 173.906H198.431L212.972 193.293V117.127C212.972 113.454 211.513 109.932 208.916 107.335C206.319 104.738 202.796 103.279 199.123 103.279Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3575 150.543H91.203V124.231H95.3575V135.49H100.038V124.231H104.193V150.543H100.038V139.285H95.3575V150.543Z",
    fill: "#82D379"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.253 124.273H111.408V150.585H107.253V124.273Z",
    fill: "#82D379"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.997 124.273H131.751V128.026H127.43V150.543H123.276V128.026H118.969L118.997 124.273Z",
    fill: "#82D379"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 150.543H133.524V124.231H137.678V135.49H142.345V124.231H146.5V150.543H142.345V139.285H137.65L137.678 150.543Z",
    fill: "#82D379"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.701 135.338H159.365V139.091H153.701V146.79H160.833V150.543H149.574V124.231H160.833V127.984H153.701V135.338Z",
    fill: "#82D379"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.008 150.543C171.67 149.503 171.543 148.406 171.634 147.317V143.162C171.634 140.725 170.817 139.825 168.865 139.825H167.48V150.516H163.325V124.204H169.557C173.836 124.204 175.678 126.198 175.678 130.242V132.305C175.678 135.005 174.806 136.778 172.908 137.637C174.972 138.509 175.678 140.489 175.678 143.176V147.233C175.603 148.316 175.759 149.401 176.135 150.419L172.008 150.543ZM167.508 128.026V136.099H169.128C170.665 136.099 171.607 135.421 171.607 133.33V130.726C171.607 128.857 170.97 127.957 169.502 127.957L167.508 128.026Z",
    fill: "#82D379"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.602 135.338H188.266V139.091H182.602V146.79H189.72V150.543H178.462V124.231H189.72V127.984H182.602V135.338Z",
    fill: "#82D379"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.809 144.727L192.282 135.227V124.273H196.437V135.227L195.911 144.727H192.809ZM196.326 146.569V150.543H192.352V146.569H196.326Z",
    fill: "#82D379"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M393.001 104.664C393.001 104.664 387.877 102.85 386.714 107.433C385.55 112.017 392.336 113.721 393.167 113.721C393.998 113.721 395.313 112.571 394.483 109.926C393.652 107.281 393.001 104.664 393.001 104.664Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M422.082 93.4189C422.082 93.4189 421.584 100.038 421.584 102.684C421.584 105.329 424.354 106.326 425.738 106.326C427.123 106.326 427.733 109.469 426.902 112.779C426.071 116.089 423.259 118.069 416.474 118.069C409.688 118.069 405.561 115.092 405.395 112.945C405.229 110.799 406.877 101.52 409.702 99.0968C412.527 96.6733 422.082 93.4189 422.082 93.4189Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M397.308 113.763V116.324C397.308 116.728 397.425 117.122 397.644 117.461C397.862 117.8 398.173 118.068 398.54 118.236C399.729 118.738 400.992 119.042 402.279 119.136C404.872 119.136 407.434 118.569 409.785 117.474C410.111 117.335 410.388 117.103 410.582 116.808C410.777 116.512 410.88 116.166 410.879 115.812V113.139C410.876 112.976 410.833 112.817 410.754 112.674C410.675 112.532 410.562 112.411 410.426 112.322C410.289 112.233 410.132 112.179 409.97 112.165C409.808 112.15 409.644 112.176 409.494 112.239L408.954 112.516C408.954 112.516 400.784 113.555 397.308 113.763Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M393.679 92.0898C392.774 95.7276 392.162 99.4325 391.851 103.168C391.353 109.289 391.851 114.912 394.33 115.078C396.031 115.081 397.697 114.601 399.136 113.693C399.136 113.693 404.924 114.358 406.905 113.375L408.899 112.378L410.38 102.684C410.38 102.684 410.547 87.6306 407.735 86.6335C404.924 85.6364 393.679 92.0898 393.679 92.0898Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M398.139 98.8755L396.823 102.351C396.823 102.351 394.164 103.016 394.496 104.332C394.829 105.647 396.588 105.453 396.588 105.453",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M402.39 100.385C402.127 101.105 401.587 101.576 401.213 101.437C400.839 101.299 400.728 100.592 401.005 99.8584C401.282 99.1245 401.808 98.6536 402.196 98.806C402.584 98.9583 402.695 99.7061 402.39 100.385Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M396.158 98.7093C395.881 99.4433 395.355 99.9141 394.967 99.7756C394.58 99.6371 394.496 98.917 394.76 98.1969C395.023 97.4768 395.563 96.9921 395.951 97.1306C396.338 97.2691 396.421 97.9892 396.158 98.7093Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M401.116 95.7315C401.116 95.7315 404.26 94.9006 404.592 97.8918",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M396.989 94.9006C396.989 94.9006 394.219 93.9174 393.347 96.2854",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M399.136 113.762L403.595 111.948",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M395.77 84.4728C395.77 84.4728 390.48 78.1856 386.506 82.811C382.531 87.4364 383.736 94.4021 390.813 94.7345C397.889 95.0668 405.866 88.1149 405.866 88.1149C405.866 88.1149 405.035 97.2133 407.015 100.357C408.996 103.5 410.491 105.647 410.491 105.647C410.491 105.647 413.261 107.461 417.942 103.833C422.622 100.205 423.73 91.3693 420.421 85.456C417.111 79.5428 411.322 76.1915 404.37 78.5318C397.418 80.8722 395.77 84.4728 395.77 84.4728Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M407.237 105.495C407.237 105.495 413.192 100.038 413.192 103.182C413.192 106.326 410.422 109.137 408.234 108.472",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M407.237 105.495C407.237 105.495 413.192 100.038 413.192 103.182C413.192 106.326 410.422 109.137 408.234 108.472",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M394.496 108.015C395.279 108.579 396.219 108.882 397.183 108.882C398.147 108.882 399.087 108.579 399.87 108.015",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M425.227 118.472C435.802 107.219 435.252 89.5244 423.999 78.9498C412.746 68.3752 395.052 68.9251 384.477 80.178C373.903 91.4309 374.452 109.126 385.705 119.7C396.958 130.275 414.653 129.725 425.227 118.472Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M595.125 326.775C611.017 323.059 620.889 307.163 617.173 291.27C613.457 275.377 597.561 265.506 581.668 269.222C565.776 272.938 555.904 288.834 559.62 304.727C563.336 320.619 579.232 330.491 595.125 326.775Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M598.483 306.712C598.483 308.656 597.906 310.557 596.826 312.174C595.746 313.791 594.21 315.051 592.413 315.796C590.617 316.54 588.64 316.735 586.733 316.355C584.825 315.976 583.073 315.039 581.698 313.664C580.323 312.289 579.387 310.537 579.007 308.63C578.628 306.723 578.823 304.746 579.567 302.949C580.311 301.152 581.571 299.617 583.188 298.536C584.805 297.456 586.706 296.879 588.651 296.879C591.258 296.879 593.759 297.915 595.603 299.759C597.447 301.603 598.483 304.104 598.483 306.712Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M602.707 313.262C604.828 310.615 606.158 307.422 606.544 304.052C606.93 300.681 606.355 297.271 604.887 294.212C603.418 291.154 601.116 288.573 598.245 286.767C595.373 284.96 592.05 284.002 588.658 284.002C585.265 284.002 581.942 284.96 579.071 286.767C576.199 288.573 573.897 291.154 572.429 294.212C570.96 297.271 570.386 300.681 570.772 304.052C571.157 307.422 572.487 310.615 574.609 313.262H602.707Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M595.672 308.166H581.187C580.339 308.166 579.5 307.999 578.717 307.675C577.934 307.35 577.223 306.875 576.623 306.276C576.024 305.677 575.549 304.965 575.224 304.182C574.9 303.399 574.733 302.56 574.733 301.713C574.731 300.865 574.897 300.025 575.221 299.241C575.544 298.457 576.02 297.745 576.619 297.145C577.219 296.546 577.931 296.07 578.715 295.747C579.499 295.423 580.339 295.257 581.187 295.259H595.672C596.52 295.257 597.36 295.423 598.144 295.747C598.927 296.07 599.64 296.546 600.239 297.145C600.839 297.745 601.314 298.457 601.638 299.241C601.961 300.025 602.127 300.865 602.125 301.713C602.125 303.424 601.445 305.066 600.235 306.276C599.025 307.486 597.383 308.166 595.672 308.166Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M577.697 301.186C577.993 300.355 578.534 299.634 579.249 299.115C579.963 298.597 580.817 298.307 581.699 298.283C582.581 298.259 583.45 298.503 584.191 298.981C584.933 299.46 585.512 300.151 585.853 300.965",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M591.24 301.186C591.537 300.355 592.078 299.634 592.792 299.115C593.507 298.597 594.361 298.307 595.243 298.283C596.125 298.259 596.994 298.503 597.735 298.981C598.476 299.46 599.056 300.151 599.397 300.965",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M586.283 304.178C586.347 304.786 586.635 305.35 587.09 305.759C587.545 306.168 588.136 306.395 588.748 306.395C589.36 306.395 589.95 306.168 590.405 305.759C590.861 305.35 591.148 304.786 591.213 304.178H586.283Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M611.93 305.202C611.683 305.202 611.438 305.153 611.209 305.059C610.981 304.964 610.773 304.825 610.598 304.651C610.423 304.476 610.285 304.268 610.19 304.04C610.095 303.811 610.047 303.566 610.047 303.319V299.04C610.047 298.792 610.095 298.547 610.19 298.319C610.285 298.09 610.423 297.883 610.598 297.708C610.773 297.533 610.981 297.394 611.209 297.3C611.438 297.205 611.683 297.156 611.93 297.156C612.177 297.156 612.422 297.205 612.651 297.3C612.879 297.394 613.087 297.533 613.262 297.708C613.437 297.883 613.575 298.09 613.67 298.319C613.765 298.547 613.813 298.792 613.813 299.04V303.277C613.819 303.528 613.774 303.777 613.682 304.011C613.59 304.244 613.452 304.457 613.277 304.636C613.101 304.815 612.892 304.958 612.66 305.055C612.429 305.152 612.181 305.202 611.93 305.202Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M564.873 305.202C564.626 305.202 564.381 305.153 564.152 305.059C563.924 304.964 563.716 304.825 563.541 304.651C563.366 304.476 563.228 304.268 563.133 304.04C563.038 303.811 562.99 303.566 562.99 303.319V299.04C562.99 298.792 563.038 298.547 563.133 298.319C563.228 298.09 563.366 297.883 563.541 297.708C563.716 297.533 563.924 297.394 564.152 297.3C564.381 297.205 564.626 297.156 564.873 297.156C565.12 297.156 565.365 297.205 565.594 297.3C565.822 297.394 566.03 297.533 566.205 297.708C566.38 297.883 566.518 298.09 566.613 298.319C566.708 298.547 566.756 298.792 566.756 299.04V303.277C566.762 303.528 566.717 303.777 566.625 304.011C566.533 304.244 566.395 304.457 566.22 304.636C566.044 304.815 565.835 304.958 565.604 305.055C565.372 305.152 565.124 305.202 564.873 305.202Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M568.349 299.303C567.826 299.299 567.326 299.089 566.958 298.718C566.589 298.347 566.383 297.845 566.383 297.322V294.22C566.377 290.859 567.38 287.574 569.263 284.79C569.398 284.552 569.581 284.345 569.8 284.182C570.019 284.019 570.269 283.903 570.535 283.841C570.801 283.779 571.077 283.772 571.345 283.822C571.614 283.872 571.869 283.977 572.095 284.13C572.321 284.284 572.513 284.482 572.659 284.713C572.805 284.944 572.901 285.202 572.942 285.473C572.983 285.743 572.968 286.018 572.897 286.282C572.826 286.546 572.702 286.792 572.531 287.005C571.091 289.136 570.324 291.649 570.329 294.22V297.322C570.329 297.848 570.121 298.351 569.749 298.723C569.378 299.094 568.874 299.303 568.349 299.303Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M606.598 286.895C606.436 286.895 606.276 286.855 606.133 286.778C605.99 286.7 605.869 286.588 605.781 286.452C604.512 284.559 602.795 283.009 600.782 281.938C598.77 280.868 596.525 280.311 594.246 280.317H583.25C580.971 280.311 578.725 280.868 576.713 281.938C574.701 283.009 572.984 284.559 571.714 286.452C571.565 286.67 571.336 286.821 571.076 286.87C570.817 286.919 570.548 286.864 570.329 286.715C570.22 286.642 570.126 286.549 570.053 286.439C569.98 286.33 569.93 286.207 569.905 286.078C569.881 285.949 569.882 285.816 569.91 285.688C569.938 285.559 569.991 285.438 570.066 285.33C571.518 283.171 573.479 281.403 575.776 280.181C578.072 278.959 580.634 278.321 583.236 278.323H594.232C596.837 278.321 599.402 278.961 601.701 280.185C604 281.41 605.963 283.181 607.415 285.344C607.49 285.452 607.542 285.575 607.569 285.704C607.595 285.833 607.596 285.966 607.57 286.095C607.544 286.224 607.493 286.347 607.419 286.456C607.344 286.565 607.249 286.657 607.138 286.729C606.978 286.835 606.791 286.893 606.598 286.895Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M609.146 299.303C608.621 299.303 608.117 299.094 607.746 298.723C607.375 298.352 607.166 297.848 607.166 297.323V294.221C607.171 291.649 606.404 289.136 604.964 287.006C604.799 286.791 604.679 286.545 604.613 286.282C604.547 286.019 604.535 285.746 604.579 285.478C604.623 285.211 604.721 284.955 604.867 284.728C605.014 284.5 605.205 284.304 605.43 284.153C605.655 284.002 605.909 283.899 606.175 283.85C606.442 283.801 606.715 283.807 606.979 283.868C607.243 283.929 607.492 284.044 607.71 284.205C607.928 284.365 608.11 284.569 608.246 284.804C610.125 287.584 611.123 290.865 611.113 294.221V297.323C611.113 297.845 610.906 298.347 610.538 298.718C610.169 299.089 609.669 299.299 609.146 299.303Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M568.598 308C567.563 308 566.569 307.588 565.837 306.856C565.104 306.124 564.693 305.13 564.693 304.095V297.891C564.693 296.855 565.104 295.862 565.837 295.129C566.569 294.397 567.563 293.985 568.598 293.985C569.634 293.985 570.627 294.397 571.36 295.129C572.092 295.862 572.504 296.855 572.504 297.891V304.095C572.504 305.13 572.092 306.124 571.36 306.856C570.627 307.588 569.634 308 568.598 308Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M569 293.985H568.197V308H569V293.985Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M612.332 297.891C612.332 295.734 610.583 293.985 608.426 293.985C606.269 293.985 604.521 295.734 604.521 297.891V304.095C604.521 306.251 606.269 308 608.426 308C610.583 308 612.332 306.251 612.332 304.095V297.891Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M608.828 293.985H608.025V308H608.828V293.985Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M588.72 292.711C590.096 292.706 591.449 292.359 592.657 291.701C593.866 291.044 594.892 290.096 595.644 288.944L597.348 286.299C594.648 284.805 591.608 284.032 588.522 284.057C585.436 284.081 582.408 284.901 579.732 286.438L582.28 289.623C583.057 290.584 584.038 291.36 585.152 291.894C586.265 292.428 587.485 292.707 588.72 292.711Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M588.858 309.758C589.019 309.758 589.149 309.628 589.149 309.468C589.149 309.307 589.019 309.177 588.858 309.177C588.698 309.177 588.568 309.307 588.568 309.468C588.568 309.628 588.698 309.758 588.858 309.758Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M589.149 310.479C589.146 310.404 589.114 310.333 589.059 310.282C589.005 310.23 588.933 310.201 588.858 310.202C588.821 310.2 588.783 310.205 588.748 310.219C588.713 310.232 588.681 310.252 588.654 310.278C588.626 310.303 588.605 310.335 588.59 310.369C588.575 310.404 588.568 310.441 588.568 310.479C588.568 310.556 588.598 310.63 588.653 310.684C588.707 310.739 588.781 310.769 588.858 310.769C588.936 310.769 589.01 310.739 589.064 310.684C589.119 310.63 589.149 310.556 589.149 310.479Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M588 310.326C588.073 310.304 588.135 310.253 588.171 310.186C588.207 310.118 588.215 310.039 588.194 309.966C588.166 309.894 588.112 309.834 588.043 309.798C587.975 309.763 587.895 309.753 587.82 309.772C587.747 309.795 587.685 309.845 587.649 309.912C587.613 309.98 587.604 310.059 587.626 310.132C587.654 310.204 587.707 310.264 587.776 310.3C587.845 310.335 587.925 310.345 588 310.326Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M589.814 310.326C589.887 310.304 589.949 310.253 589.985 310.186C590.021 310.118 590.029 310.039 590.008 309.966C589.982 309.892 589.929 309.83 589.86 309.794C589.79 309.758 589.709 309.75 589.634 309.772C589.598 309.783 589.564 309.801 589.536 309.825C589.507 309.85 589.483 309.88 589.466 309.913C589.45 309.947 589.44 309.984 589.438 310.021C589.435 310.059 589.441 310.097 589.454 310.132C589.476 310.205 589.527 310.267 589.594 310.303C589.662 310.339 589.741 310.348 589.814 310.326Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M552.091 146.999H441.899V97.9061V84.8887L454.931 97.9061H552.091V146.999Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M552.091 218.11H441.899V169.031V156.014L454.931 169.031H552.091V218.11Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M515.476 114.801H541.414",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M479.179 114.801H508.815",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 114.801H473.986",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M503.622 122.958H541.414",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 122.958H496.961",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M534.005 131.101H541.414",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M492.515 131.101H528.078",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 131.101H486.588",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M515.476 183.697H541.414",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M479.179 183.697H508.815",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 183.697H473.986",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M503.622 191.854H541.414",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 191.854H496.961",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M534.005 199.996H541.414",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M492.515 199.996H528.078",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 199.996H486.588",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M441.899 418.094H552.091V299.372V286.354L539.06 299.372H441.899V418.094Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M515.476 315.575H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M479.179 315.575H508.815",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 315.575H473.986",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M503.622 323.718H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 323.718H496.961",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M534.005 331.875H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M492.515 331.875H528.078",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 331.875H486.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M515.476 338.535H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M479.179 338.535H508.815",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 338.535H473.986",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M503.622 346.692H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 346.692H496.961",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M534.005 354.835H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M492.515 354.835H528.078",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 354.835H486.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M515.476 361.51H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M479.179 361.51H508.815",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 361.51H473.986",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M503.622 369.653H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 369.653H496.961",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M534.005 377.81H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M492.515 377.81H528.078",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 377.81H486.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M515.476 384.471H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M479.179 384.471H508.815",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 384.471H473.986",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M503.622 392.627H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 392.627H496.961",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M534.005 400.77H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M492.515 400.77H528.078",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 400.77H486.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M588.401 484.11C604.723 484.11 617.954 470.879 617.954 454.557C617.954 438.236 604.723 425.005 588.401 425.005C572.08 425.005 558.849 438.236 558.849 454.557C558.849 470.879 572.08 484.11 588.401 484.11Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M598.483 463.268C598.486 465.213 597.912 467.115 596.833 468.734C595.754 470.353 594.219 471.615 592.423 472.362C590.627 473.108 588.649 473.304 586.741 472.927C584.833 472.549 583.08 471.614 581.703 470.239C580.327 468.864 579.389 467.113 579.008 465.205C578.628 463.297 578.822 461.32 579.566 459.522C580.309 457.725 581.57 456.188 583.187 455.107C584.804 454.026 586.706 453.449 588.651 453.449C591.256 453.449 593.755 454.483 595.598 456.324C597.442 458.165 598.479 460.662 598.483 463.268Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M602.707 469.818C604.828 467.171 606.158 463.978 606.544 460.608C606.93 457.237 606.355 453.827 604.887 450.769C603.418 447.711 601.116 445.13 598.245 443.323C595.373 441.517 592.05 440.558 588.658 440.558C585.265 440.558 581.942 441.517 579.071 443.323C576.199 445.13 573.897 447.711 572.429 450.769C570.96 453.827 570.386 457.237 570.772 460.608C571.157 463.978 572.487 467.171 574.609 469.818H602.707Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M595.672 464.722H581.187C580.339 464.722 579.5 464.555 578.717 464.23C577.934 463.906 577.223 463.431 576.623 462.831C576.024 462.232 575.549 461.521 575.224 460.738C574.9 459.955 574.733 459.116 574.733 458.268C574.733 457.421 574.9 456.582 575.224 455.799C575.549 455.016 576.024 454.304 576.623 453.705C577.223 453.106 577.934 452.63 578.717 452.306C579.5 451.982 580.339 451.815 581.187 451.815H595.672C596.519 451.815 597.359 451.982 598.141 452.306C598.924 452.63 599.636 453.106 600.235 453.705C600.834 454.304 601.31 455.016 601.634 455.799C601.958 456.582 602.125 457.421 602.125 458.268C602.125 459.98 601.445 461.621 600.235 462.831C599.025 464.042 597.383 464.722 595.672 464.722Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M577.697 457.742C577.993 456.911 578.534 456.189 579.249 455.671C579.963 455.153 580.817 454.863 581.699 454.839C582.581 454.815 583.45 455.058 584.191 455.537C584.933 456.015 585.512 456.707 585.853 457.521",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M591.24 457.742C591.537 456.911 592.078 456.189 592.792 455.671C593.507 455.153 594.361 454.863 595.243 454.839C596.125 454.815 596.994 455.058 597.735 455.537C598.476 456.015 599.056 456.707 599.397 457.521",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M586.283 460.733C586.347 461.342 586.635 461.905 587.09 462.315C587.545 462.724 588.136 462.951 588.748 462.951C589.36 462.951 589.95 462.724 590.405 462.315C590.861 461.905 591.148 461.342 591.213 460.733H586.283Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M611.93 461.758C611.43 461.758 610.951 461.56 610.598 461.206C610.245 460.853 610.047 460.374 610.047 459.875V455.609C610.047 455.11 610.245 454.631 610.598 454.278C610.951 453.924 611.43 453.726 611.93 453.726C612.429 453.726 612.908 453.924 613.262 454.278C613.615 454.631 613.813 455.11 613.813 455.609V459.889C613.81 460.386 613.61 460.861 613.257 461.211C612.904 461.562 612.427 461.758 611.93 461.758Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M564.873 461.758C564.374 461.758 563.895 461.56 563.541 461.206C563.188 460.853 562.99 460.374 562.99 459.875V455.609C562.99 455.11 563.188 454.631 563.541 454.278C563.895 453.924 564.374 453.726 564.873 453.726C565.373 453.726 565.852 453.924 566.205 454.278C566.558 454.631 566.756 455.11 566.756 455.609V459.889C566.753 460.386 566.553 460.861 566.2 461.211C565.847 461.562 565.37 461.758 564.873 461.758Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M568.349 455.873C567.826 455.869 567.326 455.659 566.958 455.288C566.589 454.917 566.383 454.415 566.383 453.892V450.777C566.379 447.416 567.382 444.131 569.263 441.346C569.574 440.956 570.021 440.699 570.513 440.624C571.006 440.549 571.509 440.663 571.922 440.943C572.334 441.222 572.626 441.647 572.739 442.133C572.852 442.618 572.778 443.128 572.531 443.562C571.091 445.692 570.324 448.205 570.329 450.777V453.892C570.329 454.418 570.121 454.921 569.749 455.293C569.378 455.664 568.874 455.873 568.349 455.873Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M606.598 443.451C606.438 443.45 606.279 443.411 606.137 443.336C605.995 443.262 605.873 443.154 605.781 443.022C604.513 441.126 602.797 439.573 600.784 438.5C598.772 437.428 596.526 436.869 594.245 436.873H583.25C580.972 436.874 578.729 437.435 576.718 438.504C574.707 439.574 572.989 441.12 571.714 443.008C571.641 443.115 571.548 443.207 571.44 443.278C571.332 443.35 571.21 443.399 571.083 443.423C570.956 443.448 570.825 443.447 570.698 443.421C570.571 443.394 570.45 443.344 570.343 443.271C570.236 443.198 570.144 443.105 570.073 442.997C570.001 442.888 569.952 442.767 569.928 442.64C569.903 442.513 569.904 442.382 569.93 442.255C569.956 442.128 570.007 442.007 570.08 441.9C571.532 439.741 573.493 437.973 575.789 436.751C578.086 435.529 580.648 434.891 583.25 434.893H594.245C596.85 434.893 599.414 435.534 601.713 436.758C604.012 437.983 605.975 439.753 607.429 441.914C607.504 442.022 607.556 442.145 607.583 442.274C607.609 442.403 607.61 442.536 607.584 442.665C607.558 442.794 607.506 442.917 607.432 443.025C607.358 443.134 607.263 443.227 607.152 443.299C606.986 443.403 606.794 443.456 606.598 443.451Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M609.146 455.873C608.621 455.873 608.117 455.664 607.746 455.293C607.375 454.921 607.166 454.418 607.166 453.893V450.777C607.169 448.21 606.402 445.701 604.964 443.576C604.813 443.36 604.706 443.117 604.65 442.86C604.594 442.603 604.59 442.337 604.638 442.078C604.685 441.82 604.784 441.573 604.928 441.353C605.072 441.133 605.259 440.944 605.477 440.797C605.695 440.649 605.94 440.547 606.198 440.496C606.456 440.444 606.722 440.445 606.98 440.497C607.238 440.55 607.482 440.653 607.7 440.801C607.917 440.949 608.103 441.139 608.246 441.36C610.123 444.141 611.122 447.422 611.113 450.777V453.893C611.113 454.415 610.906 454.917 610.538 455.288C610.169 455.659 609.669 455.869 609.146 455.873Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M568.598 464.569C567.563 464.569 566.569 464.158 565.837 463.426C565.104 462.693 564.693 461.7 564.693 460.664V454.446C564.693 453.411 565.104 452.417 565.837 451.685C566.569 450.952 567.563 450.541 568.598 450.541C569.634 450.541 570.627 450.952 571.36 451.685C572.092 452.417 572.504 453.411 572.504 454.446V460.664C572.5 461.699 572.087 462.69 571.356 463.422C570.624 464.153 569.633 464.566 568.598 464.569Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M569 450.541H568.197V464.556H569V450.541Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M612.332 454.446C612.332 452.289 610.583 450.541 608.426 450.541C606.269 450.541 604.521 452.289 604.521 454.446V460.65C604.521 462.807 606.269 464.556 608.426 464.556C610.583 464.556 612.332 462.807 612.332 460.65V454.446Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M608.828 450.541H608.025V464.556H608.828V450.541Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M588.72 449.267C590.096 449.262 591.449 448.915 592.657 448.257C593.866 447.6 594.892 446.652 595.644 445.5L597.348 442.869C594.647 441.379 591.608 440.608 588.524 440.63C585.439 440.652 582.412 441.466 579.732 442.994L582.28 446.179C583.057 447.14 584.038 447.916 585.152 448.45C586.265 448.984 587.485 449.264 588.72 449.267Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M588.858 466.315C589.019 466.315 589.149 466.184 589.149 466.024C589.149 465.863 589.019 465.733 588.858 465.733C588.698 465.733 588.568 465.863 588.568 466.024C588.568 466.184 588.698 466.315 588.858 466.315Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M588.858 467.339C589.019 467.339 589.149 467.209 589.149 467.048C589.149 466.888 589.019 466.757 588.858 466.757C588.698 466.757 588.568 466.888 588.568 467.048C588.568 467.209 588.698 467.339 588.858 467.339Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M588 466.882C588.073 466.86 588.134 466.809 588.171 466.742C588.207 466.675 588.215 466.596 588.194 466.522C588.166 466.45 588.112 466.39 588.043 466.355C587.975 466.319 587.895 466.31 587.82 466.328C587.749 466.354 587.689 466.404 587.653 466.471C587.618 466.537 587.608 466.615 587.626 466.688C587.637 466.726 587.655 466.761 587.68 466.792C587.705 466.822 587.736 466.847 587.771 466.865C587.806 466.884 587.845 466.894 587.884 466.897C587.923 466.9 587.963 466.895 588 466.882Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M589.814 466.882C589.887 466.86 589.949 466.809 589.985 466.742C590.021 466.675 590.029 466.596 590.008 466.522C589.982 466.448 589.929 466.386 589.86 466.35C589.79 466.314 589.709 466.306 589.634 466.328C589.598 466.339 589.564 466.357 589.536 466.382C589.507 466.406 589.483 466.436 589.466 466.469C589.45 466.503 589.44 466.54 589.438 466.578C589.435 466.615 589.441 466.653 589.454 466.688C589.463 466.726 589.48 466.761 589.504 466.791C589.528 466.821 589.557 466.846 589.591 466.865C589.625 466.883 589.662 466.894 589.701 466.897C589.739 466.9 589.778 466.895 589.814 466.882Z",
    fill: "#263238"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M441.899 526.001H552.091V455.928V442.911L539.06 455.928H441.899V526.001Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M515.476 472.131H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M479.179 472.131H508.815",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 472.131H473.986",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M503.622 480.288H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 480.288H496.961",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M534.005 488.43H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M492.515 488.43H528.078",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 488.43H486.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M515.476 495.105H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M479.179 495.105H508.815",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 495.105H473.986",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M503.622 503.248H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 503.248H496.961",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M534.005 511.391H541.414",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M492.515 511.391H528.078",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M456.953 511.391H486.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M607.651 32.6523H550.485C549.885 35.8183 548.201 38.6763 545.721 40.7339C543.241 42.7915 540.122 43.9199 536.899 43.9249H455.055C451.833 43.9199 448.714 42.7915 446.234 40.7339C443.754 38.6763 442.069 35.8183 441.47 32.6523H384.373C379.599 32.6523 375.019 34.5491 371.643 37.9253C368.267 41.3015 366.37 45.8806 366.37 50.6552V533.964C366.37 538.738 368.267 543.318 371.643 546.694C375.019 550.07 379.599 551.967 384.373 551.967H607.651C612.425 551.967 617.004 550.07 620.381 546.694C623.757 543.318 625.654 538.738 625.654 533.964V50.6552C625.654 45.8806 623.757 41.3015 620.381 37.9253C617.004 34.5491 612.425 32.6523 607.651 32.6523Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M625.654 65.2653V50.6691C625.654 45.8944 623.757 41.3153 620.381 37.9391C617.004 34.5629 612.425 32.6662 607.651 32.6662H550.485C549.885 35.8322 548.201 38.6901 545.721 40.7477C543.241 42.8053 540.122 43.9338 536.899 43.9388H455.055C451.831 43.9332 448.71 42.8027 446.23 40.7424C443.75 38.682 442.067 35.8209 441.47 32.6523H384.373C379.599 32.6523 375.019 34.5491 371.643 37.9253C368.267 41.3015 366.37 45.8806 366.37 50.6552V65.2653H625.654Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M390.12 45.6973C390.12 49.2425 386.132 50.5165 386.118 53.217V53.397H389.982V54.6018H384.83V53.5909C384.83 49.8518 388.846 49.0486 388.846 45.6973C388.846 44.4786 388.445 43.8416 387.461 43.8416C386.478 43.8416 386.077 44.534 386.077 45.5727V46.6113H384.858V45.6973C384.858 43.897 385.675 42.7061 387.489 42.7061C389.303 42.7061 390.12 43.897 390.12 45.6973Z",
    fill: "#263238"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M396.546 45.6974V46.0021C396.605 46.4993 396.502 47.0023 396.253 47.4364C396.003 47.8705 395.621 48.2126 395.161 48.4117C395.626 48.6122 396.012 48.9586 396.262 49.3984C396.512 49.8382 396.611 50.3475 396.546 50.849V51.7492C396.546 53.5495 395.701 54.7266 393.901 54.7266C392.101 54.7266 391.256 53.5495 391.256 51.7492V50.946H392.488V51.8323C392.488 52.8986 392.918 53.5356 393.873 53.5356C394.829 53.5356 395.258 52.9124 395.258 51.7215V50.8213C395.258 49.6581 394.76 49.1041 393.776 49.0626H393.001V47.8993H393.776C393.98 47.9023 394.181 47.8604 394.367 47.7766C394.552 47.6928 394.717 47.5691 394.849 47.4144C394.981 47.2597 395.078 47.0778 395.132 46.8815C395.186 46.6853 395.196 46.4796 395.161 46.2791V45.6974C395.161 44.4926 394.732 43.8695 393.776 43.8695C392.821 43.8695 392.391 44.5203 392.391 45.5866V46.196H391.159V45.6974C391.159 43.8971 392.004 42.7339 393.804 42.7339C395.604 42.7339 396.546 43.8833 396.546 45.6974Z",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M399.08 46.5698V48.2039H397.82V46.5698H399.08ZM399.08 52.9678V54.6019H397.82V52.9678H399.08Z",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M401.739 47.6224C401.911 47.3147 402.166 47.0609 402.474 46.8897C402.782 46.7185 403.132 46.6365 403.484 46.653C404.993 46.653 405.672 47.7609 405.672 49.4227V51.7215C405.672 53.5218 404.813 54.6989 403.013 54.6989C401.213 54.6989 400.382 53.5218 400.382 51.7215V50.9322H401.601V51.8046C401.601 52.871 402.044 53.508 402.985 53.508C403.927 53.508 404.37 52.871 404.37 51.8046V49.5473C404.37 48.481 403.941 47.844 402.985 47.844C402.81 47.8265 402.632 47.8462 402.465 47.9016C402.297 47.9571 402.143 48.0472 402.013 48.166C401.882 48.2848 401.778 48.4297 401.707 48.5913C401.636 48.7529 401.6 48.9277 401.601 49.1042V49.3673H400.368L400.687 42.8447H405.326V44.0218H401.864L401.739 47.6224Z",
    fill: "#263238"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M412.195 45.6973V45.9051H411.004V45.6004C411.004 44.5479 410.561 43.9248 409.619 43.9248C408.677 43.9248 408.234 44.5618 408.234 45.822V48.467C408.369 48.0786 408.628 47.7452 408.971 47.5176C409.313 47.2901 409.721 47.1809 410.131 47.2068C411.641 47.2068 412.319 48.287 412.319 49.9765V51.7491C412.319 53.5494 411.433 54.7265 409.633 54.7265C407.832 54.7265 406.849 53.5355 406.849 51.7352V45.6973C406.849 43.8278 407.68 42.6646 409.55 42.6646C411.419 42.6646 412.195 43.8694 412.195 45.6973ZM408.151 50.0873V51.846C408.151 52.9124 408.594 53.5494 409.536 53.5494C410.477 53.5494 410.921 52.9124 410.921 51.846V50.0596C410.921 49.0071 410.464 48.3701 409.536 48.3701C408.608 48.3701 408.151 49.0071 408.151 50.0596V50.0873Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M557.34 46.1821H554.016V54.4773H557.34V46.1821Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M561.771 44.5205H558.447V54.4775H561.771V44.5205Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M566.189 43.3433H562.865V54.4774H566.189V43.3433Z",
    fill: "#263238"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M570.62 41.2798H567.297V54.4773H570.62V41.2798Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M611.681 54.2419H591.767V42.083H611.681V54.2419ZM592.874 53.1479H610.573V43.1909H592.874V53.1479Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M605.047 44.396H594.536V51.9434H605.047V44.396Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M613.495 46.7363H610.988V49.6029H613.495V46.7363Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M584.469 51.5971C584.337 51.5994 584.208 51.5659 584.095 51.5002C580.037 49.0905 577.364 51.3201 577.254 51.4171C577.181 51.4903 577.095 51.5478 576.999 51.5861C576.904 51.6244 576.802 51.6426 576.699 51.6396C576.596 51.6366 576.495 51.6125 576.402 51.5687C576.309 51.5249 576.226 51.4624 576.159 51.3851C576.091 51.3078 576.04 51.2173 576.008 51.1194C575.977 51.0215 575.966 50.9181 575.977 50.8159C575.987 50.7136 576.019 50.6146 576.069 50.525C576.12 50.4355 576.188 50.3573 576.27 50.2954C576.409 50.1707 579.843 47.2349 584.856 50.2123C585.022 50.3179 585.141 50.4835 585.187 50.6745C585.233 50.8655 585.204 51.0671 585.106 51.237C585.04 51.3475 584.947 51.4389 584.835 51.5021C584.723 51.5653 584.597 51.5981 584.469 51.5971Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M585.964 49.1042C585.832 49.1017 585.703 49.0634 585.59 48.9934C579.732 45.5175 575.786 48.8826 575.744 48.9103C575.671 48.974 575.587 49.0227 575.495 49.0537C575.404 49.0846 575.307 49.0973 575.21 49.0908C575.114 49.0844 575.02 49.059 574.933 49.0162C574.846 48.9733 574.769 48.9138 574.705 48.8411C574.642 48.7684 574.593 48.6838 574.562 48.5922C574.531 48.5007 574.519 48.4039 574.525 48.3074C574.531 48.211 574.557 48.1168 574.6 48.0301C574.642 47.9435 574.702 47.8661 574.775 47.8025C574.775 47.8025 579.566 43.648 586.352 47.7194C586.52 47.8226 586.641 47.9883 586.688 48.1803C586.735 48.3724 586.703 48.5751 586.601 48.7442C586.535 48.8537 586.441 48.9444 586.33 49.0074C586.218 49.0705 586.092 49.1038 585.964 49.1042Z",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M587.335 46.2101C587.198 46.2074 587.065 46.1692 586.947 46.0993C579.525 41.6955 574.595 45.85 574.387 46.0301C574.236 46.1439 574.048 46.1964 573.86 46.1772C573.672 46.1579 573.498 46.0682 573.374 45.9262C573.249 45.7841 573.183 45.6002 573.189 45.4114C573.194 45.2226 573.271 45.0429 573.404 44.9083C573.473 44.9083 579.331 39.8398 587.709 44.8253C587.794 44.8752 587.868 44.9414 587.927 45.02C587.986 45.0985 588.029 45.1879 588.053 45.2831C588.077 45.3783 588.083 45.4773 588.069 45.5746C588.055 45.6719 588.022 45.7655 587.972 45.85C587.905 45.9587 587.811 46.0487 587.7 46.1116C587.588 46.1745 587.463 46.2084 587.335 46.2101Z",
    fill: "#263238"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M582.225 52.843C582.228 53.214 582.12 53.5773 581.916 53.8869C581.711 54.1964 581.42 54.4382 581.077 54.5814C580.735 54.7246 580.358 54.7628 579.994 54.6911C579.63 54.6194 579.296 54.4411 579.034 54.1788C578.771 53.9165 578.593 53.5821 578.521 53.2182C578.45 52.8542 578.488 52.4772 578.631 52.135C578.774 51.7929 579.016 51.501 579.326 51.2966C579.635 51.0923 579.998 50.9846 580.369 50.9874C580.862 50.9874 581.334 51.1829 581.682 51.5309C582.03 51.8789 582.225 52.3509 582.225 52.843Z",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M604.881 574.027H633.963",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4851 574.027H595.187",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6098 574.027H38.4822",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M218.068 387.531H196.908V571.437H218.068V387.531Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M50.281 454.128V467.062H134.618V454.128H50.281Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9501 409.48H46.0157V461.232H58.9501V409.48Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3371 461.454C64.3371 463.01 64.0304 464.551 63.4345 465.988C62.8386 467.425 61.9652 468.731 60.8643 469.831C59.7633 470.931 58.4564 471.802 57.0183 472.397C55.5801 472.991 54.039 473.296 52.4829 473.294C52.0951 473.294 51.7074 473.294 51.3335 473.294C49.1766 473.081 47.1194 472.28 45.3857 470.979C43.652 469.679 42.308 467.928 41.5001 465.916C40.6921 463.905 40.451 461.711 40.803 459.572C41.1549 457.434 42.0865 455.432 43.4964 453.786C44.9064 452.14 46.7406 450.912 48.7998 450.235C50.8589 449.559 53.0641 449.46 55.1756 449.949C57.2871 450.438 59.224 451.497 60.7758 453.01C62.3276 454.523 63.4348 456.433 63.9771 458.532C64.2135 459.488 64.3344 460.469 64.3371 461.454Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2096 417.457C65.2022 420.597 63.9505 423.607 61.7286 425.826C59.5067 428.046 56.4958 429.294 53.3554 429.297C52.9676 429.297 52.5798 429.297 52.1921 429.297C50.0341 429.091 47.9742 428.296 46.2364 427C44.4985 425.704 43.1494 423.956 42.3357 421.947C41.522 419.937 41.2749 417.743 41.6212 415.603C41.9676 413.463 42.8942 411.459 44.3002 409.809C45.7061 408.159 47.5377 406.926 49.5956 406.244C51.6535 405.563 53.859 405.458 55.972 405.943C58.0851 406.427 60.0248 407.482 61.5803 408.992C63.1357 410.502 64.2473 412.41 64.7941 414.507C65.0601 415.468 65.1998 416.46 65.2096 417.457Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4348 385.328L69.1937 394.612L72.7652 401.245L90.0064 391.962L86.4348 385.328Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8648 392.683L84.3757 397.252L78.9472 387.185L87.4501 382.601C88.1172 382.235 88.8508 382.007 89.6077 381.929C90.3645 381.85 91.1293 381.925 91.8571 382.147C92.5848 382.369 93.2608 382.734 93.8453 383.221C94.4298 383.708 94.911 384.307 95.2606 384.983C95.9555 386.323 96.0936 387.883 95.6451 389.325C95.1965 390.767 94.1975 391.973 92.8648 392.683Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6542 349.988L55.0449 385.107L47.5252 384.983L48.1207 349.863L55.6542 349.988Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6899 347.869L57.5376 357.563L46.0988 357.286L46.2511 347.592C46.2638 346.841 46.4242 346.1 46.7234 345.411C47.0225 344.721 47.4545 344.098 47.9946 343.576C48.5347 343.054 49.1724 342.643 49.8712 342.368C50.5701 342.092 51.3163 341.957 52.0675 341.97C52.8263 341.98 53.5754 342.142 54.2709 342.446C54.9664 342.749 55.5943 343.189 56.1179 343.738C56.6415 344.288 57.0502 344.936 57.3201 345.645C57.59 346.355 57.7158 347.111 57.6899 347.869Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7941 362.729L67.273 393.721L60.6258 390.19L77.133 359.197L83.7941 362.729Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5638 361.773L82.0354 370.29L71.9399 364.931L76.4545 356.4C77.1687 355.065 78.3822 354.066 79.8299 353.623C81.2777 353.179 82.8422 353.326 84.1819 354.032C85.5231 354.744 86.5271 355.959 86.9737 357.41C87.4202 358.861 87.2728 360.43 86.5638 361.773Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9545 362.59L45.3233 393.666L38.6622 397.183L22.2934 366.107L28.9545 362.59Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3124 385.121C44.0696 383.684 43.4059 382.351 42.4053 381.291C41.4046 380.231 40.112 379.492 38.691 379.167C37.2701 378.841 35.7846 378.945 34.4225 379.465C33.0605 379.984 31.8832 380.896 31.0396 382.085C30.196 383.273 29.724 384.686 29.6834 386.143C29.6428 387.6 30.0353 389.037 30.8114 390.271C31.5874 391.504 32.7121 392.48 34.0431 393.075C35.374 393.67 36.8514 393.856 38.2883 393.61C40.212 393.282 41.9268 392.203 43.0562 390.612C44.1856 389.02 44.6374 387.046 44.3124 385.121Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5135 386.091C55.5824 386.091 58.8809 382.792 58.8809 378.723C58.8809 374.654 55.5824 371.356 51.5135 371.356C47.4446 371.356 44.1462 374.654 44.1462 378.723C44.1462 382.792 47.4446 386.091 51.5135 386.091Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5543 382.975C75.776 381.534 75.5654 380.06 74.9492 378.739C74.3329 377.418 73.3387 376.31 72.0924 375.554C70.846 374.799 69.4035 374.43 67.9474 374.494C66.4913 374.558 65.0869 375.053 63.9121 375.916C62.7373 376.779 61.8447 377.97 61.3474 379.341C60.8501 380.711 60.7704 382.197 61.1183 383.613C61.4663 385.028 62.2263 386.309 63.3021 387.292C64.3779 388.275 65.7213 388.918 67.1622 389.137C68.118 389.285 69.0935 389.242 70.0329 389.012C70.9723 388.783 71.8571 388.369 72.6367 387.797C73.4162 387.225 74.0752 386.504 74.5758 385.677C75.0765 384.849 75.409 383.931 75.5543 382.975Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7162 359.751L34.2307 368.282L24.1214 373.641L19.6068 365.097C19.2542 364.433 19.0361 363.707 18.965 362.959C18.8939 362.211 18.9712 361.456 19.1925 360.738C19.4139 360.02 19.7748 359.353 20.2547 358.775C20.7345 358.197 21.3238 357.719 21.9888 357.369C23.3301 356.664 24.8959 356.519 26.3439 356.966C27.7919 357.412 29.0043 358.414 29.7162 359.751Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1418 399.344C74.1418 404.853 71.9532 410.137 68.0576 414.032C64.162 417.928 58.8784 420.116 53.3692 420.116C52.6768 420.116 51.9844 420.116 51.3335 420.033C47.5548 419.659 43.9511 418.255 40.914 415.976C37.877 413.697 35.5227 410.629 34.1073 407.105C32.6918 403.582 32.2692 399.738 32.8855 395.991C33.5017 392.244 35.1332 388.738 37.6026 385.853C40.072 382.968 43.2849 380.816 46.8919 379.629C50.499 378.443 54.3623 378.268 58.0619 379.123C61.7615 379.979 65.1559 381.832 67.8761 384.481C70.5963 387.13 72.5383 390.475 73.4909 394.151C73.9204 395.848 74.139 397.592 74.1418 399.344Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1418 399.343C74.1418 404.853 71.9532 410.136 68.0576 414.032C64.162 417.927 58.8784 420.116 53.3692 420.116C52.6768 420.116 51.9844 420.116 51.3335 420.033C50.5376 416.959 50.4569 413.744 51.0975 410.635C51.738 407.525 53.0828 404.604 55.0286 402.095C56.9743 399.586 59.4692 397.557 62.3216 396.163C65.174 394.769 68.308 394.047 71.4829 394.053C72.1615 394.053 72.8677 394.053 73.5186 394.15C73.9388 395.849 74.1481 397.593 74.1418 399.343Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M178.74 461.828C182.267 446.755 172.907 431.677 157.834 428.15C142.761 424.623 127.683 433.983 124.156 449.056C120.629 464.129 129.989 479.207 145.062 482.734C160.134 486.261 175.213 476.901 178.74 461.828Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M156.655 467.976C163.58 465.088 166.852 457.133 163.964 450.208C161.076 443.283 153.121 440.011 146.196 442.899C139.272 445.787 135.999 453.742 138.887 460.667C141.776 467.592 149.731 470.864 156.655 467.976Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M146.624 574.027H270.983L272.769 565.607C273.486 562.244 272.842 558.734 270.979 555.843C269.116 552.953 266.185 550.917 262.826 550.18C245.197 546.219 207.031 544.793 207.031 544.793C197.836 545.084 172.244 546.178 154.615 550.194C151.279 550.955 148.377 552.999 146.537 555.884C144.697 558.768 144.067 562.261 144.782 565.607L146.624 574.027Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M238.73 546.843C222.804 545.375 207.072 544.793 207.072 544.793C201.284 544.973 188.986 545.485 176.274 546.843C179.985 559.514 192.559 568.848 207.502 568.848C222.444 568.848 235.018 559.472 238.73 546.843Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M337.39 514.647L345.126 504.28L277.533 453.843L269.798 464.21L337.39 514.647Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M303.753 545.249L314.12 552.984L345.069 511.508L334.703 503.772L303.753 545.249Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M330.503 500.367C331.436 499.117 332.605 498.063 333.945 497.266C335.285 496.468 336.769 495.942 338.313 495.719C339.856 495.495 341.428 495.577 342.94 495.962C344.451 496.346 345.872 497.024 347.121 497.958L348.021 498.692C349.623 500.153 350.793 502.025 351.405 504.104C352.017 506.184 352.047 508.391 351.491 510.487C350.936 512.582 349.816 514.485 348.255 515.989C346.693 517.492 344.749 518.539 342.635 519.015C340.52 519.491 338.315 519.378 336.26 518.688C334.205 517.998 332.378 516.757 330.979 515.102C329.58 513.446 328.661 511.438 328.323 509.297C327.985 507.156 328.241 504.963 329.063 502.957C329.435 502.038 329.918 501.168 330.503 500.367Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M303.457 533.506C305.213 530.899 307.933 529.096 311.018 528.493C314.103 527.891 317.301 528.538 319.909 530.294C320.228 530.501 320.532 530.737 320.837 530.972C322.509 532.352 323.77 534.164 324.484 536.211C325.198 538.258 325.337 540.462 324.885 542.582C324.434 544.703 323.41 546.659 321.924 548.238C320.439 549.817 318.548 550.958 316.459 551.537C314.37 552.117 312.162 552.112 310.076 551.524C307.989 550.936 306.103 549.787 304.624 548.202C303.145 546.617 302.129 544.657 301.686 542.535C301.244 540.412 301.392 538.209 302.114 536.165C302.449 535.227 302.901 534.333 303.457 533.506Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M267.861 548.343L287.349 550.257L288.085 542.759L268.598 540.845L267.861 548.343Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M266.676 538.7L276.287 539.641L275.165 551.025L265.554 550.083C264.045 549.936 262.655 549.195 261.692 548.024C260.729 546.853 260.27 545.347 260.416 543.837C260.567 542.327 261.31 540.938 262.484 539.974C263.657 539.011 265.165 538.553 266.676 538.7Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M285.925 543.547C287.447 541.278 289.402 539.333 291.677 537.821C293.952 536.309 296.503 535.26 299.183 534.736C301.864 534.211 304.622 534.22 307.299 534.762C309.976 535.305 312.52 536.37 314.785 537.897C315.353 538.284 315.893 538.686 316.419 539.115C319.347 541.535 321.555 544.711 322.804 548.298C324.053 551.885 324.295 555.745 323.503 559.46C322.71 563.175 320.915 566.601 318.311 569.367C315.708 572.132 312.396 574.131 308.736 575.145C305.076 576.16 301.208 576.152 297.552 575.121C293.896 574.091 290.593 572.078 288.001 569.302C285.41 566.525 283.629 563.091 282.853 559.373C282.076 555.655 282.334 551.795 283.599 548.214C284.172 546.565 284.954 544.997 285.925 543.547Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M263.546 565.122L289.304 545.859L293.445 551.385L267.687 570.634L263.546 565.122Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M260.873 564.831L267.95 559.472L274.237 567.781L267.161 573.085C266.049 573.917 264.654 574.273 263.28 574.076C261.906 573.878 260.667 573.143 259.835 572.033C259.037 570.933 258.699 569.566 258.893 568.221C259.087 566.877 259.797 565.661 260.873 564.831Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M296.81 551.8C297.137 550.378 297.035 548.891 296.515 547.527C295.996 546.163 295.084 544.984 293.893 544.139C292.703 543.295 291.289 542.823 289.83 542.783C288.371 542.744 286.933 543.139 285.699 543.917C284.465 544.696 283.49 545.824 282.897 547.157C282.305 548.491 282.122 549.971 282.372 551.409C282.621 552.847 283.292 554.178 284.3 555.234C285.307 556.29 286.606 557.023 288.03 557.34C289.928 557.762 291.917 557.417 293.561 556.379C295.206 555.341 296.374 553.695 296.81 551.8Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M310.464 584.482L314.287 558.06L319.951 558.863L316.142 585.285L310.464 584.482Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M308.733 585.881L309.772 578.611L318.372 579.843L317.333 587.1C317.253 587.666 317.063 588.21 316.773 588.702C316.482 589.194 316.098 589.624 315.641 589.967C315.185 590.311 314.665 590.561 314.112 590.703C313.559 590.846 312.983 590.878 312.417 590.797C311.277 590.633 310.249 590.023 309.559 589.101C308.868 588.179 308.571 587.021 308.733 585.881Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M322.166 557.132C321.514 556.116 320.576 555.316 319.47 554.833C318.363 554.35 317.138 554.206 315.95 554.419C314.762 554.632 313.663 555.192 312.793 556.028C311.923 556.865 311.321 557.941 311.062 559.12C310.803 560.299 310.899 561.528 311.338 562.653C311.777 563.777 312.54 564.746 313.53 565.437C314.519 566.128 315.692 566.511 316.899 566.536C318.106 566.561 319.293 566.228 320.311 565.579C321.676 564.704 322.638 563.323 322.986 561.739C323.334 560.156 323.039 558.499 322.166 557.132Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M284.97 580.965L302.142 553.767L307.972 557.423L290.814 584.635L284.97 580.965Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M282.38 581.629L287.074 574.151L295.951 579.691L291.243 587.183C290.502 588.355 289.327 589.186 287.975 589.495C286.623 589.804 285.204 589.565 284.028 588.831C282.857 588.092 282.026 586.92 281.717 585.57C281.408 584.221 281.646 582.804 282.38 581.629Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M311.295 556.62C311.09 555.177 310.461 553.829 309.488 552.745C308.515 551.661 307.242 550.89 305.83 550.53C304.419 550.171 302.932 550.238 301.559 550.725C300.186 551.212 298.989 552.095 298.118 553.263C297.248 554.431 296.744 555.831 296.671 557.286C296.598 558.741 296.958 560.185 297.707 561.435C298.455 562.684 299.558 563.684 300.875 564.306C302.192 564.928 303.665 565.144 305.105 564.929C307.026 564.644 308.757 563.61 309.917 562.053C311.077 560.495 311.573 558.542 311.295 556.62Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M279.483 479.497C292.5 471.118 296.259 453.773 287.88 440.757C279.501 427.741 262.157 423.981 249.141 432.36C236.124 440.739 232.365 458.083 240.744 471.1C249.122 484.116 266.467 487.875 279.483 479.497Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M276.671 461.602C279.8 454.782 276.807 446.718 269.987 443.59C263.167 440.462 255.103 443.455 251.975 450.274C248.847 457.094 251.84 465.158 258.659 468.286C265.479 471.415 273.543 468.422 276.671 461.602Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M207.488 400.382C232.352 400.382 252.509 380.225 252.509 355.361C252.509 330.496 232.352 310.34 207.488 310.34C182.623 310.34 162.467 330.496 162.467 355.361C162.467 380.225 182.623 400.382 207.488 400.382Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M271.855 385.343C281.524 373.221 287.575 358.616 289.312 343.208C291.049 327.8 288.402 312.215 281.675 298.244C274.948 284.274 264.414 272.486 251.285 264.236C238.157 255.986 222.966 251.61 207.46 251.61C191.955 251.61 176.764 255.986 163.635 264.236C150.506 272.486 139.973 284.274 133.246 298.244C126.519 312.215 123.871 327.8 125.609 343.208C127.346 358.616 133.396 373.221 143.065 385.343H271.855Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M257.868 302.89H155.03C148.774 302.89 143.702 307.961 143.702 314.218V350.667C143.702 356.923 148.774 361.995 155.03 361.995H257.868C264.125 361.995 269.196 356.923 269.196 350.667V314.218C269.196 307.961 264.125 302.89 257.868 302.89Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M157.274 330.046C158.634 326.238 161.112 322.93 164.385 320.555C167.658 318.18 171.572 316.849 175.614 316.737C179.656 316.624 183.637 317.736 187.037 319.926C190.436 322.115 193.095 325.281 194.664 329.007",
    stroke: "#263238",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M219.301 330.046C220.661 326.238 223.139 322.93 226.412 320.555C229.685 318.18 233.599 316.849 237.641 316.737C241.683 316.624 245.664 317.736 249.064 319.926C252.463 322.115 255.122 325.281 256.691 329.007",
    stroke: "#263238",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M196.631 343.742C196.978 346.488 198.316 349.013 200.393 350.844C202.469 352.674 205.142 353.684 207.91 353.684C210.678 353.684 213.351 352.674 215.428 350.844C217.505 349.013 218.842 346.488 219.19 343.742H196.631Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M314.065 348.423C311.781 348.423 309.59 347.516 307.974 345.9C306.359 344.285 305.451 342.094 305.451 339.809V320.214C305.449 319.082 305.671 317.96 306.103 316.913C306.535 315.867 307.169 314.916 307.969 314.114C308.769 313.313 309.72 312.677 310.765 312.243C311.811 311.81 312.933 311.586 314.065 311.586C315.197 311.585 316.319 311.806 317.366 312.238C318.412 312.67 319.363 313.304 320.165 314.104C320.966 314.904 321.602 315.855 322.036 316.901C322.469 317.947 322.693 319.068 322.693 320.2V339.796C322.694 340.929 322.472 342.052 322.04 343.099C321.607 344.147 320.971 345.099 320.17 345.9C319.368 346.702 318.416 347.337 317.369 347.77C316.321 348.203 315.198 348.425 314.065 348.423Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5565 348.423C97.4241 348.425 96.3026 348.203 95.2559 347.771C94.2092 347.339 93.258 346.705 92.4567 345.905C91.6554 345.105 91.0197 344.155 90.5859 343.109C90.1522 342.063 89.9289 340.942 89.9289 339.809V320.214C89.9271 319.08 90.149 317.958 90.582 316.91C91.0149 315.863 91.6503 314.911 92.4518 314.109C93.2533 313.308 94.2051 312.672 95.2527 312.239C96.3003 311.807 97.423 311.585 98.5565 311.586C99.6876 311.586 100.808 311.809 101.853 312.242C102.898 312.675 103.847 313.309 104.647 314.109C105.447 314.909 106.082 315.859 106.514 316.904C106.947 317.949 107.17 319.069 107.17 320.2V339.796C107.172 340.928 106.951 342.049 106.518 343.096C106.086 344.143 105.452 345.094 104.652 345.895C103.852 346.697 102.902 347.332 101.856 347.766C100.81 348.2 99.6888 348.423 98.5565 348.423Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M126.17 260.001C118.551 271.259 114.489 284.546 114.51 298.139V312.376",
    stroke: "#263238",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M289.692 260.056C283.457 250.767 275.031 243.155 265.158 237.892C255.285 232.63 244.268 229.878 233.08 229.881H182.741C171.568 229.873 160.565 232.612 150.7 237.858C140.835 243.103 132.411 250.693 126.17 259.96",
    stroke: "#263238",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M301.297 312.376V298.14C301.318 284.571 297.276 271.307 289.692 260.057",
    stroke: "#263238",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M121.379 297.045H109.829C103.144 297.045 97.7256 302.464 97.7256 309.149V349.157C97.7256 355.841 103.144 361.26 109.829 361.26H121.379C128.063 361.26 133.482 355.841 133.482 349.157V309.149C133.482 302.464 128.063 297.045 121.379 297.045Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M117.432 297.045H113.79V361.26H117.432V297.045Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M303.79 297.045H292.24C285.555 297.045 280.136 302.464 280.136 309.149V349.157C280.136 355.841 285.555 361.26 292.24 361.26H303.79C310.474 361.26 315.893 355.841 315.893 349.157V309.149C315.893 302.464 310.474 297.045 303.79 297.045Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M299.843 297.045H296.201V361.26H299.843V297.045Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M207.779 291.215C214.087 291.217 220.296 289.639 225.837 286.625C231.379 283.611 236.078 279.257 239.505 273.96L247.316 261.871C234.939 255.036 221.011 251.503 206.873 251.612C192.735 251.721 178.863 255.469 166.594 262.494L178.351 277.09C181.888 281.495 186.368 285.051 191.46 287.495C196.553 289.94 202.13 291.211 207.779 291.215Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M209.731 367.977C209.731 367.703 209.65 367.435 209.498 367.208C209.346 366.98 209.129 366.802 208.876 366.698C208.623 366.593 208.345 366.565 208.076 366.619C207.808 366.672 207.561 366.804 207.367 366.998C207.174 367.192 207.042 367.438 206.988 367.707C206.935 367.976 206.962 368.254 207.067 368.507C207.172 368.76 207.349 368.976 207.577 369.129C207.805 369.281 208.073 369.362 208.346 369.362C208.714 369.362 209.066 369.216 209.326 368.956C209.585 368.697 209.731 368.344 209.731 367.977Z",
    fill: "#263238"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M209.731 372.63C209.731 372.356 209.65 372.088 209.498 371.861C209.346 371.633 209.129 371.455 208.876 371.351C208.623 371.246 208.345 371.218 208.076 371.272C207.808 371.325 207.561 371.457 207.367 371.651C207.174 371.844 207.042 372.091 206.988 372.36C206.935 372.628 206.962 372.907 207.067 373.16C207.172 373.413 207.349 373.629 207.577 373.781C207.805 373.934 208.073 374.015 208.346 374.015C208.714 374.015 209.066 373.869 209.326 373.609C209.585 373.349 209.731 372.997 209.731 372.63Z",
    fill: "#263238"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M204.455 371.91C204.708 371.746 204.901 371.505 205.004 371.222C205.108 370.94 205.117 370.631 205.029 370.343C204.941 370.055 204.762 369.803 204.519 369.626C204.275 369.449 203.981 369.356 203.68 369.362C203.427 369.525 203.234 369.766 203.13 370.049C203.027 370.331 203.018 370.64 203.106 370.928C203.193 371.216 203.373 371.468 203.616 371.645C203.86 371.822 204.154 371.915 204.455 371.91Z",
    fill: "#263238"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M212.778 371.91C212.992 371.906 213.203 371.853 213.393 371.754C213.583 371.655 213.747 371.513 213.873 371.34C213.999 371.167 214.084 370.967 214.119 370.755C214.155 370.544 214.141 370.327 214.078 370.122C214.016 369.917 213.907 369.73 213.76 369.574C213.612 369.418 213.431 369.299 213.23 369.225C213.029 369.151 212.813 369.125 212.6 369.149C212.387 369.173 212.182 369.246 212.002 369.362C211.788 369.366 211.578 369.419 211.388 369.518C211.198 369.617 211.033 369.759 210.907 369.932C210.781 370.105 210.697 370.306 210.661 370.517C210.626 370.728 210.64 370.945 210.702 371.15C210.764 371.355 210.874 371.543 211.021 371.698C211.168 371.854 211.349 371.973 211.551 372.047C211.752 372.121 211.967 372.147 212.18 372.123C212.393 372.099 212.598 372.026 212.778 371.91Z",
    fill: "#263238"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M262.826 419.936C245.197 415.962 207.031 414.535 207.031 414.535C197.836 414.826 172.244 415.92 154.615 419.95C151.277 420.708 148.373 422.752 146.533 425.637C144.692 428.522 144.063 432.017 144.782 435.363L161.11 511.751C161.912 515.455 163.956 518.773 166.903 521.156C169.85 523.539 173.523 524.842 177.312 524.851H240.253C244.043 524.842 247.716 523.539 250.663 521.156C253.61 518.773 255.654 515.455 256.456 511.751L272.769 435.363C273.486 432 272.842 428.49 270.979 425.599C269.116 422.709 266.185 420.673 262.826 419.936Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M254.794 418.468C235.669 415.615 207.072 414.535 207.072 414.535C193.07 414.936 179.1 416.092 165.223 417.997L183.724 524.851H234.008L254.794 418.468Z",
    fill: "#82D379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M223.58 437.759H192.947C186.691 437.759 181.619 442.831 181.619 449.087V464.043C181.619 470.299 186.691 475.371 192.947 475.371H223.58C229.836 475.371 234.908 470.299 234.908 464.043V449.087C234.908 442.831 229.836 437.759 223.58 437.759Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M199.317 453.255H190.69V461.883H199.317V453.255Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M212.57 453.255H203.943V461.883H212.57V453.255Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M225.837 453.255H217.209V461.883H225.837V453.255Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0346 500.7H240.53C242.367 500.7 244.128 501.429 245.426 502.728C246.725 504.026 247.454 505.787 247.454 507.624V593.858H80.1104V507.624C80.1104 505.787 80.8399 504.026 82.1385 502.728C83.437 501.429 85.1982 500.7 87.0346 500.7Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M247.454 531.692C226.432 537.024 204.857 550.595 164.655 569.706C125.879 588.152 94.1388 587.834 80.1104 586.407V593.858H247.454V531.692Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M247.454 588.692H80.1104V593.872H247.454V588.692Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M172.41 547.286C172.41 548.992 171.904 550.66 170.956 552.079C170.008 553.498 168.66 554.604 167.084 555.257C165.507 555.91 163.773 556.08 162.099 555.748C160.426 555.415 158.888 554.593 157.682 553.386C156.475 552.18 155.653 550.642 155.321 548.969C154.988 547.295 155.159 545.561 155.812 543.984C156.465 542.408 157.57 541.06 158.989 540.112C160.408 539.164 162.076 538.658 163.782 538.658C166.071 538.658 168.265 539.567 169.883 541.185C171.501 542.803 172.41 544.998 172.41 547.286Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChat);
export default __webpack_public_path__ + "static/media/no-chat.9dca0407f176a8470e48ca0923f25844.svg";
export { ForwardRef as ReactComponent };